export const BAY_AREA = 'Bay Area';
export const BAY_AREA_CITIES = [
  'Concord',
  'Manteca',
  'Martinez',
  'Menlo Park',
  'Oakland',
  'Pleasanton',
  'Sacramento',
  'San Francisco',
  'San Jose',
];

export const NO_GREASE_CONCORD_SHOP = 'a920a0aa-3f5c-4de6-90a1-7c853316459c';



// WEBPACK FOOTER //
// ./src/app/applicationServices/bayAreaShops/constants.js